@if (loading()) {
  <p class="loading-hint">Cargando skills…</p>
} @else {
  <div class="bisual-table">
    <div class="bisual-table-container">
      <table mat-table [dataSource]="skills_data_source">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Skill</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayed_columns"></tr>
      </table>
    </div>
  </div>
}
